<script>
import Vue from 'vue';
import debounce from 'lodash/debounce';
import { mapState } from 'vuex';
import { Loading } from 'element-ui';

Vue.use(Loading);

export default {
    name: 'oembed-video',

    props: {
        baseClass: {
            type: String,
            default: 'embed-responsive embed-responsive-16by9 m-t-15'
        },
    },

    computed: {
        ...mapState('oembed', [
            'url',
            'videoData',
            'isLoading'
        ])
    }
};
</script>

<template>
    <div v-if="url" v-loading="isLoading">
        <div :class="[baseClass]" v-html="videoData.code"></div>
    </div>
</template>